module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "file"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Sample")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('div', {
    attrs: {
      "id": "file"
    }
  }, [_c('v-server-table', {
    attrs: {
      "url": "/",
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "checkbox",
      fn: function(props) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.markedRows),
            expression: "markedRows"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": props.row,
            "checked": Array.isArray(_vm.markedRows) ? _vm._i(_vm.markedRows, props.row) > -1 : (_vm.markedRows)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.markedRows,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = props.row,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.markedRows = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.markedRows = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.markedRows = $$c
              }
            }, function($event) {
              _vm.$_admin_file_list_unmarkAll()
            }]
          }
        })]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "filter__checkbox"
    },
    slot: "filter__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allMarked),
      expression: "allMarked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allMarked) ? _vm._i(_vm.allMarked, null) > -1 : (_vm.allMarked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allMarked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allMarked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allMarked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allMarked = $$c
        }
      }, function($event) {
        _vm.$_admin_file_list_toggleAll()
      }]
    }
  }), _vm._v("\n                                             \n                                            "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.$t('deleteSelected')
    },
    on: {
      "click": function($event) {
        _vm.$_admin_file_list_removeAll()
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-trash"
  })])])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header col-md-2"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("List")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header col-md-8 text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 table-responsive"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84fb7972"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ListSample.vue
// module id = 1501
// module chunks = 1